import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ConfigEffects } from './config.effects';
import { ConfigFacade } from './config.facade';
import { configReducer } from './config.reducer';
import { ConfigService } from './config.service';

@NgModule({
  imports: [
    StoreModule.forFeature('config', configReducer),
    EffectsModule.forFeature([
      ConfigEffects,
    ]),
  ],
  providers: [
    ConfigService,
    ConfigFacade
  ]
})
export class ConfigModule {}
